import Layout from "../../../components/layout/layout.js";
import PullReport from "../../../components/pull-report/PullReport.js";

function PullScoutingReportsPage({ component, ...rest }) {
  return (
    <Layout
      Component={() => (
        <PullReport
          reportType="Scouting"
          pageTitle="Pull Report (Scouting)"
        />
      )}
      controlsDisabled={true}
      {...rest}
    />
  );
}

export default PullScoutingReportsPage;
